export default __webpack_public_path__ + "static/media/title_case2.a6d34606.jpg";